import React from 'react';
import './Table.css';

export function Table({ className = '', children, ...props }) {
  return (
    <div className="cw-table-wrap">
      <table className={`cw-table${className ? ` ${className}` : ''}`} {...props}>
        {children}
      </table>
    </div>
  );
}

export function TableCode({ className = '', children, ...props }) {
  return (
    <span className={`cw-table-code${className ? ` ${className}` : ''}`} {...props}>
      {children}
    </span>
  );
}

export default Table;
